import api, { ServerResponse } from "./agritech";

export type ClientField = {
  id: number;
  client_id: number;
  name: string;
  farm?: string;
  field_type: "soil" | "substrate";
  crop_type?: string;
  timezone: string;
  auto_drain_facility?: string;
  ec_division_factor?: number;
  runoff_multiplication_factor?: number;
  chart_runoff_multiplication_factor?: number;
  conductivity_line?: number;
  import: 0 | 1;
  import_frequency: 5 | 15;
  last_import?: string;
  import_summary?: string; // JSON
  deleted_at?: string;
  loggers: any[];
  sensors: any[];
};

export type Client = {
  id: number | null;
  name?: string;
  module_access?: { module_id: number }[];
  users?: { id: number; name: string }[];
  fields?: ClientField[];
  directory?: string;
  api_config?: string; // JSON
  last_api_sync?: string;
  deleted_at?: string;
};
type Frequency = [value: number, unit: "minutes" | "hours" | "days"];
export type CostaAPIConfig = {
  syncFrequency: Frequency;
  api: "costa";
};
export type KeegroveAPIConfig = {
  syncFrequency: Frequency;
  api: "keegrove";
  endpoint: string;
  apiKey: string;
};
export type APIConfig = CostaAPIConfig | KeegroveAPIConfig;

export const KEEGROVE_DEFAULT_ENDPOINT =
  "https://keegrove.haygrove.com:8064/api/SupplierData";

export type KeegroveTestSummary = {
  ok: boolean;
  summary?: Record<
    "Agronomic" | "AmbientClimate" | "Area" | "SoilClimate",
    { rowsInserted: number; batchesSent: number }
  >;
  error?: string;
};

export async function listClients(token: string) {
  const response = await api.get<ServerResponse<Client[]>>(`/clients`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return {
    ...response.data,
    data: response.data.data.filter((client) => !client.deleted_at),
  };
}

export async function listArchivedClients(token: string) {
  const response = await api.get<ServerResponse<Client[]>>(
    `/clients/archived`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function getClient(token: string, id: number) {
  const response = await api.get<ServerResponse<Client>>(`/clients/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function saveClient(token: string, client: Client) {
  const response = await api.post(
    `/clients`,
    { ...client },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function updateClient(token: string, id: number, client: Client) {
  const response = await api.patch(
    `/clients/${id}`,
    { ...client },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function archiveClient(token: string, id: number) {
  const response = await api.delete(`/clients/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });
  return response.data;
}

export async function restoreClient(token: string, id: number) {
  const response = await api.post(
    `/clients/${id}/restore`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function testKeegrovePush(token: string, id: number) {
  const response = await api.post<ServerResponse<KeegroveTestSummary>>(
    `/clients/${id}/keegrove/test`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}
